import {
  CheckCircleFilled,
  LeftOutlined,
  RightOutlined,
  RocketOutlined,
} from '@ant-design/icons';
import { Button, Modal, Tag } from 'antd';
import { useState } from 'react';
import styles from 'styles/components/welcomePanel.module.scss';
import { COLORS } from 'utils/constants';

const WelcomePanel = ({ close = () => {} }) => {
  const [currentStepIndex, setCurrentStepIndex] = useState(0);

  const STEPS = [
    {
      title: 'How to list Opportunities and get backlinks',
      description: (
        <div>
          <div>
            Go to the <b>Browse opportunities</b> tab and use the filters to
            find the right opportunity for you.
          </div>
          <div>
            <img
              src="/img/welcome/browse-opportunities.png"
              alt="browse-opportunities"
              className={styles.image}
            />
          </div>
        </div>
      ),
    },
    {
      title: 'How to exchange backlinks',
      description: (
        <div>
          <div>
            1. Give backlinks to other domains and earn Karma Points.
            <br />
            2. Use these Karma Points to request backlinks from others.
            <br />
            <br />
            Use the metrics (Domain Rating, Organic Traffic, etc.) to find the
            right opportunity for you.
          </div>
          <div>
            <img
              className={styles.image}
              src="/img/welcome/give-backlinks.png"
              alt="give-backlinks"
            />
          </div>
        </div>
      ),
    },
    {
      title: 'Follow the requests statuses',
      description: (
        <div>
          <div>
            In the History tab, you can see the status of your pending requests
            as well as the history.
          </div>
          <div>
            <img
              src="/img/welcome/history.png"
              alt="history"
              className={styles.image}
            />
          </div>
        </div>
      ),
    },
    {
      title: null,
      description: (
        <div>
          <div style={{ textAlign: 'center' }}>
            <div>
              <CheckCircleFilled
                style={{ fontSize: 88, color: COLORS.ACTION, marginBottom: 4 }}
              />
            </div>
            <h2>You know everything now!</h2>
            <div>You're ready to enter the backlink exchange world!</div>
          </div>
        </div>
      ),
    },
  ];

  const nextStep = () => {
    if (currentStepIndex < STEPS.length - 1) {
      setCurrentStepIndex(currentStepIndex + 1);
    }
  };
  const previousStep = () => {
    if (currentStepIndex > 0) {
      setCurrentStepIndex(currentStepIndex - 1);
    }
  };

  const isLastStep = currentStepIndex === STEPS.length - 1;
  const isFirstStep = currentStepIndex === 0;

  return (
    <div className={styles.wrapper}>
      <Modal
        width={580}
        open={true}
        onCancel={close}
        closable={false}
        footer={null}
        maskClosable={false}
      >
        <h1 className={styles.title}>First time on KarmaLinks?</h1>
        <p className={styles.description}>
          We're glad to have you onboard! <br />
          We've prepared a few steps to help you get started.
        </p>

        <div className={styles.stepWrapper}>
          {!isLastStep && (
            <div className={styles.step}>
              <Tag
                style={{
                  background: '#0f0f0f',
                }}
              >
                {`${currentStepIndex + 1}/3`}
              </Tag>
            </div>
          )}
          {STEPS[currentStepIndex].title && (
            <h2 className={styles.stepTitle}>
              {STEPS[currentStepIndex].title}
            </h2>
          )}
          <div className={styles.stepDescription}>
            {STEPS[currentStepIndex].description}
          </div>
          {isLastStep ? (
            <div style={{ textAlign: 'center', marginTop: 24 }}>
              <Button
                type="primary"
                size="large"
                onClick={close}
                icon={<RocketOutlined />}
              >
                Start exchanging backlinks
              </Button>
            </div>
          ) : (
            <div className={styles.buttons}>
              {!isFirstStep ? (
                <Button onClick={previousStep} icon={<LeftOutlined />}>
                  {' '}
                </Button>
              ) : (
                <div />
              )}
              <Button
                style={{ minWidth: 200 }}
                onClick={nextStep}
                type="primary"
                icon={<RightOutlined />}
              >
                Got it!
              </Button>
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default WelcomePanel;
